export default __webpack_public_path__ + "_/images/beer/therese_von_bayern/beer-liquid-a641ebffbfdb6879724d9cb21d4b4e8e3aac5da09566a873823db47bc0fc82a7.png";